module.exports = __webpack_public_path__ + "static/media/V10.39c971de.mp4";